/**
 * FleetManager V3 - Badge Component
 */

import React from 'react';

const VARIANTS = {
  critical: 'bg-red-500/20 text-red-400',
  warning: 'bg-amber-500/20 text-amber-400',
  info: 'bg-blue-500/20 text-blue-400',
  success: 'bg-emerald-500/20 text-emerald-400',
  neutral: 'bg-slate-500/20 text-slate-400',
  purple: 'bg-purple-500/20 text-purple-400'
};

const SIZES = {
  sm: 'px-1.5 py-0.5 text-xs',
  md: 'px-2 py-1 text-xs',
  lg: 'px-2.5 py-1 text-sm'
};

export function Badge({
  children,
  variant = 'neutral',
  size = 'sm',
  className = ''
}) {
  return (
    <span className={`
      inline-flex items-center rounded-full font-medium
      ${VARIANTS[variant] || VARIANTS.neutral}
      ${SIZES[size] || SIZES.sm}
      ${className}
    `}>
      {children}
    </span>
  );
}

export default Badge;
